module.exports = __webpack_public_path__ + "static/media/glass-whiskey-rocks.4c38fe58.svg";